var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-wrapper"},[_c('div',{staticClass:"progress-bar",class:{
      'has-background-danger': _vm.hasError,
      'has-background-success': _vm.progress === 100
    },style:(_vm.width)})])}
var staticRenderFns = []

export { render, staticRenderFns }